import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { ToastContainer } from 'react-toastify';

// Components
import withLocalization from '~/hoc/withLocalization';
import applicationRouter from '~/hoc/applicationRouter';
import newlogo from '../../assets/img/new-logo.png';

class LoginPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPassword: false,
        };
    }

    componentWillUnmount() {
        const { authStore } = this.props;
        authStore.reset();
    }

    handleEmailChange = (e) => this.props.authStore.setEmail(e.target.value);

    handlePasswordChange = (e) => this.props.authStore.setPassword(e.target.value);

    handleSubmitForm = (e) => {
        e.preventDefault();
        const { authStore } = this.props;
        authStore
            .login()
            .then((data) => {
                if (data && data.requires2FACode === true) {
                    this.props.router.navigate('/login/verify-2fa');
                } else if (data && data.requires2FASetup === true) {
                    this.props.router.navigate('/login/setup-2fa', { state: { canSkip2FASetup: data.canSkip2FASetup } });
                } else {
                    const lastPage = sessionStorage.getItem('lastPage');
                    if (lastPage) {
                        sessionStorage.removeItem('lastPage');
                        this.props.router.navigate(`${lastPage}`);
                    } else {
                        this.props.router.navigate('/admin');
                    }
                }
            })
            .catch((e) => {
                console.error(e);
            });
    };

    render() {
        const { t } = this.props;
        const { showPassword } = this.state;

        return (
            <div>
                <div className="auth-page-wrapper">
                    <ToastContainer />
                    <div className="auth-page-card">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h2 className="fs22 loginTitle">{t('Login').toUpperCase()}</h2>
                            <img src={newlogo} alt="Logo" style={{ height: 42, cursor: 'pointer' }} onClick={() => this.props.router.navigate('/')} />
                        </div>
                        <form className="login-container" onSubmit={this.handleSubmitForm}>
                            <div className="row">
                                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                    <div className="form-group business-name">
                                        <label htmlFor="loginEmail" className="fw-bold">
                                            {t('Email')} / {t('Username')}
                                        </label>
                                        <label className="red-star">*</label>
                                        <input
                                            id="loginEmail"
                                            type="text"
                                            className="form-control login-input mb_25 mt-12"
                                            placeholder={`${t('Email address')} / ${t('Username')}`}
                                            required
                                            onChange={this.handleEmailChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                    <div className="form-group business-name">
                                        <label htmlFor="loginPassword" className="fw-bold">
                                            {t('Password')}
                                        </label>
                                        <label className="red-star">*</label>
                                        <div className="position-relative w-100">
                                            <input
                                                id="loginPassword"
                                                type={showPassword ? 'text' : 'password'}
                                                className="form-control login-input mt-12 mb_25"
                                                placeholder={t('Password')}
                                                required
                                                onChange={this.handlePasswordChange}
                                            />
                                            <span
                                                className="position-absolute color-gray cursor-pointer"
                                                style={{ top: 12, right: 10 }}
                                                onClick={() => this.setState({ showPassword: !showPassword })}
                                            >
                                                {showPassword
                                                    ? <i className="fas fa-eye-slash" />
                                                    : <i className="fas fa-eye" />}
                                            </span>
                                        </div>
                                        <div className="d-flex w-100 justify-content-end align-items-end">
                                            <Link className="loginFooter border-none text-decoration-none" to="/forgot-password">
                                                {t('Forgot password')}?
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button className="btn btn-block fwBold fs18 loginbutton" type="submit">
                                {t('Login')}
                            </button>
                        </form>
                        <div className="d-flex w-100 justify-content-between mt-3 mb-3">
                            <Link className="fs18 loginFooter border-none text-decoration-none" to="/">
                                {t('Back to home')}
                            </Link>
                            <Link className="fs18 loginFooter border-none text-decoration-none" to="/loginAsGuest">
                                {t('Login as guest')}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default inject('authStore', 'commonStore')(applicationRouter(withLocalization(observer(LoginPage))));
